module.exports = __webpack_public_path__ + "static/img/page40.fa666aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page40.png
// module id = SHyl
// module chunks = 0